import PropTypes from 'prop-types'
import {Flex, Box} from '@chakra-ui/react'

const SubsectionGroup = ({children}) => {
  return (
    <Flex direction="column" gap="sm">
      <Box>{children}</Box>
    </Flex>
  )
}

SubsectionGroup.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SubsectionGroup
